'use client'

import { useEffect, useRef, useState } from 'react'
import clsx from 'clsx'

import styles from './ProductDescription.module.scss'

interface ProductDescriptionProps {
  descriptionShort: string
  descriptionLong: string
}

const ProductDescription = ({
  descriptionShort,
  descriptionLong
}: ProductDescriptionProps) => {
  const [open, setOpen] = useState(false)
  const descriptionRef = useRef<HTMLDivElement>(null)
  const [isOverflowing, setIsOverflowing] = useState(false)

  useEffect(() => {
    if (descriptionRef.current) {
      setIsOverflowing(descriptionRef.current.clientHeight > 120)
    }
  }, [])

  const toggleOpen = () => setOpen(prev => !prev)

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>Opis produktu</h2>
      <div
        ref={descriptionRef}
        className={clsx(styles.collapseContainer, {
          [styles.collapsed]: !open,
          [styles.overflowing]: isOverflowing
        })}
      >
        <div dangerouslySetInnerHTML={{ __html: descriptionShort || '' }} />
        <div dangerouslySetInnerHTML={{ __html: descriptionLong || '' }} />
        {isOverflowing && !open && <div className={styles.innerShadow} />}
      </div>
      {isOverflowing && (
        <div className={styles.moreButton} onClick={toggleOpen}>
          {open ? 'Zwiń opis' : 'Czytaj więcej'}
        </div>
      )}
    </div>
  )
}

export default ProductDescription
